import { render, staticRenderFns } from "./PerfilAssociacoes.vue?vue&type=template&id=2752ba3d"
import script from "./PerfilAssociacoes.vue?vue&type=script&lang=ts"
export * from "./PerfilAssociacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports